import React from 'react';
import anchorme from 'anchorme';
import { ReactComponent as LayoutIcon } from '../CourseCurriculumBlockPreview/icons/layout.svg';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import styled from 'styled-components';
import { ICoursesBlockPreviewProps } from './ICoursesBlockPreviewProps';
import CourseInBlockPreview from './CourseInBlockPreview';

const CoursesBlockContainer: any = styled.div`
  width: 100%;
  margin-top: 25px;
`;

const CoursesBlockEmptyContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #FFFFFF;
  padding: 80px 0;
`;

const CoursesBlockEmptyIconContainer: any = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CoursesBlockEmptyTitle: any = styled.h1`
  margin: 0;
  padding: 0;
  text-align: center;
  margin-top: 20px;
  font-weight: 500;
  font-size: 24px;
  line-height: 29.05px;
 color: #191b1f;
`;

const CoursesBlockEmptySubtext: any = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  margin-top: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19.36px;
  color: #666666;
`;

const CoursesBlockCoursesContainer: any = styled.div<{design: any}>`
	width: 100%;
	display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: ${(props: any) =>
    props.design.content_container_alignment === 'center' ?
    'center' :
    props.design.content_container_alignment === 'right' ?
    'flex-end' :
    'flex-start'
  };

  &.mobile {
      padding-left: 5px;
      padding-right: 5px;
  }

  @media(max-width: 768px) {
      padding-left: 5px;
      padding-right: 5px;
  }
`;

const CoursesBlockPreview: React.FC<ICoursesBlockPreviewProps> = (props) => {

  const getCourseContentElements = () => {
    if(
      !props.blockData.courses.length
    ) {
      return (
        <CoursesBlockEmptyContainer
        >
          <CoursesBlockEmptyIconContainer
          >
            <LayoutIcon
            />
          </CoursesBlockEmptyIconContainer>

          <CoursesBlockEmptyTitle
          >
            Add courses
          </CoursesBlockEmptyTitle>

          <CoursesBlockEmptySubtext
          >
            Choose courses on the left side menu to display them here.
          </CoursesBlockEmptySubtext>
        </CoursesBlockEmptyContainer>
      )
    }

    return (
      <CoursesBlockCoursesContainer
      className={`${props.view ? props.view : ''}`}
      design={props.blockData.design}
      >
      {props.blockData.courses.map((course: any, index: number) => (
          <CourseInBlockPreview
          key={`${course.id}`}
          group={props.group}
          course={course}
          design={props.blockData.design}
          view={props.view}
          buildingPreview={props.buildingPreview}
          containerBaseIdName={props.containerBaseIdName}
          pageFormsOpenState={props.pageFormsOpenState}
          setPageFormsOpenState={props.setPageFormsOpenState}
          />
      ))}
      </CoursesBlockCoursesContainer>
    )

  }

  return (
    <BlockContainer
    design={props.blockData.design}
    >
        <BlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
          <BlockTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="heading"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.heading),
          }}
          />

          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#666666"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.subtext),
          }}
          />

          <CoursesBlockContainer
		  design={props.blockData.design}
          >
            {getCourseContentElements()}
          </CoursesBlockContainer>
        </BlockContentContainer>
    </BlockContainer>
  )
}

export default CoursesBlockPreview;